import { Component, OnInit, Inject, ChangeDetectorRef } from '@angular/core';
import { FormBuilder, FormGroup, Validators, FormArray, ReactiveFormsModule } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { CommonModule } from '@angular/common';

import { UdcsService } from '../../Service/udcs-service';
import { ToastService } from '../../Service/toast-service';

@Component({
  selector: 'app-user-edit',
  standalone: true,
  imports: [CommonModule, ReactiveFormsModule],
  templateUrl: './user-edit.html',
  styleUrl: './user-edit.css',
})
export class UserEdit implements OnInit {
  userForm!: FormGroup;
  catRolesUdc: any[] = []; // Almacena [{ id: 464, description: 'ROLE_ADMIN' }, ...]

  constructor(
    private fb: FormBuilder,
    public dialogRef: MatDialogRef<UserEdit>,
    @Inject(MAT_DIALOG_DATA) public data: any, // Recibe el usuario seleccionado
    private udcService: UdcsService,
    private toastService: ToastService,
    private cdr: ChangeDetectorRef
  ) {}

  ngOnInit(): void {
    this.userForm = this.fb.group({
      userId: [{ value: this.data.userId, disabled: true }],
      an8: [this.data.an8, Validators.required],
      enabled: [this.data.enabled],
      password: [''], // Opcional, sólo si se desea cambiar
      rolesSeleccionados: this.fb.array([]) // Array de checkboxes reactivos
    });

    this.cargarRolesUDC();
  }

  cargarRolesUDC(): void {
    // 🚀 La línea roja desaparece aquí porque el método ya habita de forma legal en tu UdcsService
    this.udcService.getCatBySystemCode('ROLES').subscribe({
      next: (roles: any[]) => {
        this.catRolesUdc = roles;
        
        const formArray = this.userForm.get('rolesSeleccionados') as FormArray;
        this.catRolesUdc.forEach(rol => {
          const yaTieneRol = this.data.rolesUdcIds.includes(rol.id);
          formArray.push(this.fb.control(yaTieneRol));
        });
        this.cdr.detectChanges();
      },
      error: (err) => console.error('Error al descargar el catálogo de roles por UDC:', err)
    });
  }

  get rolesControls() {
    return (this.userForm.get('rolesSeleccionados') as FormArray).controls;
  }

  onSave(): void {
    const rawValue = this.userForm.getRawValue();
    
    // Mapeamos los checkboxes booleanos de vuelta a sus IDs numéricos reales de la UDC
    const idsRolesFinales: number[] = [];
    rawValue.rolesSeleccionados.forEach((checked: boolean, index: number) => {
      if (checked) {
        idsRolesFinales.push(this.catRolesUdc[index].id);
      }
    });

    const payload = {
      userId: this.data.userId,
      an8: rawValue.an8,
      enabled: rawValue.enabled,
      password: rawValue.password,
      rolesUdcIds: idsRolesFinales // Enviamos la matriz purificada de IDs
    };

    console.log('Despachando actualización de seguridad atómica:', payload);
    // Aquí invocarías a tu servicio HTTP que dispara el PUT hacia AdminUsersController
    this.toastService.showSuccess('Seguridad Actualizada', `Perfil de ${payload.userId} sincronizado.`);
    this.dialogRef.close(payload);
  }
}
